import { createAction, props } from '@ngrx/store';

const GET_FILE_CONTENT_DOCUMENTS = '[Documents] Get File Content Documents';
const GET_ATTACHMENT_CONTENT = '[Documents] Get Attachment Content';
const SET_FILE_CONTENT_DOCUMENTS = '[Documents] Set File Content Documents';
const SENT_FILE_CONTENT_DOCUMENTS = '[Documents] Sent File Content Documents';
const SENT_FILE_ATTACHMENT_DOCUMENTS = '[Documents] Sent File Attachments Documents';
const GET_DOCUMENTS = '[Documents] Get Documents';
const GET_DOCUMENTS_SORTING = '[Documents] Get Documents with Sorting';
const SAVE_DOCUMENTS = '[Documents] Save Documents';
const SENT_DOCUMENTS = '[Documents] Sent Documents';
const SET_DOCUMENTS = '[Documents] Set Documents';
const SET_DOCUMENTS_SORTING = '[Documents] Set Documents with Sorting';
const UPDATE_DOCUMENTS = '[Documents] Update Documents';
const DELETE_DOCUMENTS = '[Documents] Delete Documents';
const SENT_DELETE_DOCUMENTS = '[Documents] Delete Sent Documents';
const LOADER_DOCUMENTS = '[Documents] Loader Documents';
const GET_SID_BASED_DOCUMENTS = '[Documents] Get SID Based Documents';
const SET_SID_BASED_DOCUMENTS = '[Documents] Set SID Based Documents';
const GET_DOCUMENTS_BASED_SEARCH = '[Documents] Get Documents Based Search';
const DELETE_ATTACHMENTS = '[Documents] delete attachments';

const getFileContentDocuments = createAction(
  GET_FILE_CONTENT_DOCUMENTS,
  props<{ apiConstants: any; sid: any; id: any }>()
);

const getAttachmentContent = createAction(
  GET_ATTACHMENT_CONTENT,
  props<{ attachmentApiConstants: any; sid: any; id: any }>()
);

const setFileContentDocuments = createAction(
  SET_FILE_CONTENT_DOCUMENTS,
  props<{ sid: any; documentContent: any; loader: boolean }>()
);

const sentFileContentDocuments = createAction(
  SENT_FILE_CONTENT_DOCUMENTS,
  props<{
    apiConstants: any;
    sid: any;
    documentContent: any;
    attachments: any;
    status: string;
    method: string;
  }>()
);

const sentFileAttachmentDocuments = createAction(
  SENT_FILE_ATTACHMENT_DOCUMENTS,
  props<{ apiConstants: any; documentAttachment: any }>()
);

const getDocuments = createAction(GET_DOCUMENTS, props<{ apiConstants: any; first: number; rows: number }>());

const getDocumentsWithSorting = createAction(GET_DOCUMENTS_SORTING, props<{ apiConstants: any; first: number; rows: number; sortField: string; sortOrder: string }>());

const setDocuments = createAction(SET_DOCUMENTS, props<{ documentsData: any; totalRecords: number }>());

const setDocumentsWithSorting = createAction(SET_DOCUMENTS_SORTING, props<{ documentsData: any; totalRecords: number }>());
const sentDocuments = createAction(
  SENT_DOCUMENTS,
  props<{ apiConstants: any; saveDocumentsData: any; method: string }>()
);

const saveDocuments = createAction(SAVE_DOCUMENTS, props<{ saveDocumentsData: any }>());

const updateDocuments = createAction(UPDATE_DOCUMENTS, props<{ updateDocumentsData: any }>());

const sentDeleteDocuments = createAction(SENT_DELETE_DOCUMENTS, props<{ apiConstants: any; documentsId: string }>());

const deleteDocuments = createAction(DELETE_DOCUMENTS, props<{ documentsId: string }>());

const loaderDocument = createAction(LOADER_DOCUMENTS, props<{ loader: boolean }>());

const getSidBasedDocument = createAction(
  GET_SID_BASED_DOCUMENTS,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);
const setSidBasedDocument = createAction(
  SET_SID_BASED_DOCUMENTS,
  props<{
    sidDocumentData: any;
  }>()
);

const getDocumentsBasedOnSearch = createAction(
  GET_DOCUMENTS_BASED_SEARCH,
  props<{ apiConstants: any; searchFields: any; first: number; rows: number }>()
);

const deleteAttachments = createAction(DELETE_ATTACHMENTS, props<{ apiConstants: any; sid: any }>());

export {
  getFileContentDocuments,
  setFileContentDocuments,
  sentFileContentDocuments,
  sentFileAttachmentDocuments,
  getDocuments,
  saveDocuments,
  updateDocuments,
  deleteDocuments,
  setDocuments,
  sentDocuments,
  sentDeleteDocuments,
  getAttachmentContent,
  loaderDocument,
  getSidBasedDocument,
  setSidBasedDocument,
  getDocumentsBasedOnSearch,
  setDocumentsWithSorting,
  getDocumentsWithSorting,
  deleteAttachments
};
